<template>
    <div>
      <!-- modal -->
      <b-modal id="priceListDetailFormModal" ref="priceListDetailFormModal" centered size="md" no-close-on-backdrop  :title=" $t('priceListDetail.info')" :cancel-title=" $t('others.cancel_title')"
        :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <b-row>
            <b-col> 
                <label for="service-fee-euro-input">{{ $t('priceListDetail.euro') }}</label>
                <b-form-group>
                    <b-form-input id="service-fee-euro-input" type="number" size="sm" v-model="euro" maxlength="50"/>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col> 
                <label for="service-fee-usd-input">{{ $t('priceListDetail.usd') }}</label>
                <b-form-group>
                    <b-form-input id="service-fee-usd-input" type="number" size="sm" v-model="usd" maxlength="50"/>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col> 
                <label for="service-fee-gbp-input">{{ $t('priceListDetail.gbp') }}</label>
                <b-form-group>
                    <b-form-input id="service-fee-gbp-input" type="number" size="sm" v-model="gbp" maxlength="50"/>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col> 
                <label for="service-fee-tl-input">{{ $t('priceListDetail.tl') }}</label>
                <b-form-group>
                    <b-form-input id="service-fee-tl-input" type="number" size="sm" v-model="tl" maxlength="50"/>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col> 
                <label for="service-fee-explanation-input">{{ $t('priceListDetail.explanation') }}</label>
                <b-form-group>
                    <b-form-textarea id="service-fee-explanation-input" v-model="explanation" size="sm" maxlength="250" rows="3"/>
                </b-form-group>
            </b-col>
        </b-row>       
        <b-row>
            <b-col> 
                <label for="service-fee-vatRate-input">{{ $t('priceListDetail.vat_rate') }}</label>
                <b-form-group>
                    <b-form-textarea id="service-fee-vatRate-input" v-model="vatRate" size="sm" maxlength="250" rows="3"/>
                </b-form-group>
            </b-col>
        </b-row>    
      </b-modal>
    </div>
  </template>
  <script>
  export default {
    props: {
        getPriceListDetailList: {type: Function},
    },
    data() {
      return {
        id: 0,
        tl: 0,
        usd: 0,
        euro: 0,
        gbp: 0,
        vatRate: 0,
        explanation: ''
      }
    },
    methods: {
      showInfo(id) {  
        this.$refs['priceListDetailFormModal'].show()
        this.id = id
        const data = {id: this.id}
        const controller = {name : 'priceListDetail'}
        const payload = {data: data, controller: controller}
        this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
            if(response.data.resultStatus == true){
                this.euro = response.data.priceListDetail.euro
                this.usd = response.data.priceListDetail.usd
                this.gbp = response.data.priceListDetail.gbp
                this.tl = response.data.priceListDetail.tl
                this.explanation = response.data.priceListDetail.explanation
                this.vatRate = response.data.priceListDetail.vatRate
            } else {
                this.$bvModal.hide('priceListDetailFormModal')
                this.$WarningAlert(response.data.resultMessage)
            }  
        })  
      },
      addOrUpdate() {
        const data = {id: this.id, usd: this.usd, euro: this.euro, gbp: this.gbp, tl: this.tl, explanation: this.explanation, vatRate: this.vatRate}
        const controller = {name : 'priceListDetail'}
        const payload = {data: data, controller: controller}
        this.$store.dispatch('moduleAuth/save',payload).then((response) => {
            if(response.data.resultStatus == true){
                this.$bvModal.hide('priceListDetailFormModal')
                this.getPriceListDetailList()
                this.$SaveAlert()
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        })
      },
    }
  }
  </script>
  <style lang="scss">
  [dir=ltr] .modal-header .close {
      margin: -0.4rem -0.4rem -0.8rem auto;
  }
  [dir] label {
      margin-bottom: 0.2857rem;
      font-weight: bold;
  }
  .modal .modal-content {
      overflow: visible;
      margin-bottom: auto;
  }
  [dir] .invalid-tooltip {
      padding: 0.4rem 0.775rem!important;
      margin-top: -1.5rem!important;
      background-color: #ea5455!important;
      border-radius: 0.358rem!important;
      left: 20px!important
  }
  </style>
  